import { Controller } from 'stimulus';
import axios from 'axios';
import Choices from 'choices.js';

export default class extends Controller {
  static targets = ['citySelect'];

  connect() {
    this.choices = new Choices(this.citySelectTarget, {
      shouldSort: false,
      itemSelectText: '',
      searchResultLimit: 50,
    });
  }

  prefectureChange(e) {
    axios
      .get(this.data.get('url'), {
        params: { prefecture_id: e.target.value },
      })
      .then(res => {
        const items = [];
        res.data.forEach(city => {
          items.push({ value: String(city.id), label: city.text });
        });
        this.choices.clearStore();
        items[0].selected = true;
        this.choices.setChoices(items, 'value', 'label', true);
      });
  }
}
